function renderCatalog(dataArray, containerSelector) {
    const $container = $(containerSelector);

    if (!$container.length || dataArray.length === 0) return;

    createCatalogCardList(dataArray, $container);
    setTimeout(() => {
        $('.js-video-catalog-skeleton').removeClass('active');
        $('.js-video-catalog-content').addClass('active');
    }, 500);
}

function createCatalogCardList(dataArray, parentContainer) {
    const arr = dataArray;

    arr.map((card) => parentContainer.append(createCardMarkup(card)));
}

function createCardMarkup(card) {
    const baseElement =
        card.locked === true || card.years !== false ? 'div' : 'a';
    const isLink = baseElement === 'a' ? true : false;
    const baseLink = isLink ? `href='${card.linkUrl}'` : '';

    const cardMarkup = `<${baseElement} class="card js-card ${
        card.locked ? 'locked' : ''
    } active" ${baseLink}> 
        <div class='card__img-wrap'>
            ${
                card.status !== false
                    ? `<div class="card__badge badge badge--${card.status.color}">${card.status.text}</div>`
                    : ''
            }
            <img class='card__img' src="${
                card.imageUrl
            }" alt="logo" loading='lazy'>
            ${
                card.locked === true
                    ? `<a class='card__overlay' href="${card.linkUrl}">
                <div class='card__overlay-text'>Subscribers only. <span>Upgrade</span></div>
            </a>`
                    : ''
            }
        </div>
        <div class='card__info'>
            <div class="card__title">${card.title}</div>
            <div class='card__bottom'>
                ${
                    card.videosNumber !== false
                        ? `<div class="card__bottom-text">${card.videosNumber} videos</div>`
                        : ''
                }
                ${
                    card.years !== false
                        ? card.years
                              .map(
                                  (item) =>
                                      `<a class="card__button" href="${item.link}">${item.year}</a>`
                              )
                              .join('')
                        : ''
                }
            </div>
        </div>
    </${baseElement}>`;

    return cardMarkup;
}

$(document).ready(function () {
    if (
        $('.js-video-catalog-mountains').length &&
        videoCatalogMountainsData.length > 0
    ) {
        renderCatalog(
            videoCatalogMountainsData,
            $('.js-video-catalog-mountains')
        );
    }

    if (
        $('.js-video-catalog-mountains').length &&
        videoCatalogEventsData.length > 0
    ) {
        renderCatalog(videoCatalogEventsData, $('.js-video-catalog-events'));
    }

    if (
        $('.js-video-catalog-mountains').length &&
        videoCatalogTeamsData.length > 0
    ) {
        renderCatalog(videoCatalogTeamsData, $('.js-video-catalog-teams'));
    }
});
